import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { SUBURBS } from "@/lib/site";
import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import MapEmbed from "@/components/MapEmbed";
import CallStrip from "@/components/CallStrip";

const SITE_URL =
  (typeof window !== "undefined" && window.location.origin) ||
  "https://flowgridplumbing.com.au";

export default function ServiceAreasPage() {
  return (
    <>
      <SEO
        title="Service Areas — Plumbers Across Sydney"
        description="Flowgrid Plumbing services all of Sydney — CBD, Inner West, Western Sydney, South-West Sydney and beyond. Find your local Flowgrid plumber by suburb."
        canonicalPath="/service-areas"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "ItemList",
          itemListElement: SUBURBS.map((s, i) => ({
            "@type": "ListItem",
            position: i + 1,
            url: `${SITE_URL}/service-areas/${s.slug}`,
            name: `Plumber ${s.name}`,
          })),
        }}
      />
      <PageHeader
        eyebrow="Service Areas"
        title="We service all of Sydney."
        subtitle="From the CBD to the Inner West, Eastern Suburbs to the North Shore, South and beyond — Flowgrid Plumbing has you covered. Call us anytime, day or night."
      />

      <section className="bg-white py-20 md:py-24" data-testid="service-areas-section">
        <div className="fg-container grid gap-12 md:grid-cols-12">
          <div className="md:col-span-7">
            <MapEmbed height={460} />
          </div>
          <div className="md:col-span-5">
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {SUBURBS.map((s) => (
                <Link
                  to={`/service-areas/${s.slug}`}
                  key={s.slug}
                  data-testid={`area-card-${s.slug}`}
                  className="group fg-card-hover flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-4"
                >
                  <div className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-sky-100 text-blue-700 group-hover:bg-blue-600 group-hover:text-white">
                    <MapPin className="h-4 w-4" />
                  </div>
                  <div className="flex-1">
                    <div className="font-display text-lg font-bold text-slate-900">
                      {s.name}
                    </div>
                    <div className="text-xs uppercase tracking-wider text-slate-500">
                      {s.distance}
                    </div>
                  </div>
                  <ArrowRight className="h-4 w-4 text-slate-400 group-hover:text-blue-700" />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CallStrip />
    </>
  );
}
